<template>
    <span ref="tooltip" :data-trigger="trigger" data-toggle="tooltip" :data-placement="placement" :title="title">
        <slot><i :class="classes"></i></slot>
    </span>
</template>

<script>
export default {
    props: {
        title: {
            default: 'Tooltip',
        },
        trigger: {
            default: 'hover',
        },
        classes: {
            default: 'fal fa-question-circle tooltip-icon',
        },
        placement: {
            default: 'top',
        },
    },
    mounted() {
        this.$nextTick(function () {
            $(this.$refs.tooltip).tooltip();
        });
    },
};
</script>
